import React from "react";
import './Footer.css';

function Footer() {
    return (
        <footer>
            <p>Made with ☕ by Ying | <a href='https://github.com/yingmo55/Calculator' 
            rel="noopener noreferrer" target='_blank'>Source Code</a></p>
        </footer>
    )
}

export default Footer;